import { Type } from 'class-transformer'

export class Hierarchy {
  guid?: string

  label?: string

  @Type(() => Hierarchy)
  children?: Hierarchy[]

  toCreate: boolean

  constructor(toCreate = false) {
    this.toCreate = toCreate
  }
}
